export const AUDIO_TYPES = Object.freeze(["PreRecordedDisclosures", "PreRecordedDisclosuresSpanish"] as const);
export type AudioType = (typeof AUDIO_TYPES)[number];

export function isAudioType(value: string): value is AudioType {
    return (AUDIO_TYPES as readonly string[]).includes(value);
}

/**
 * Whether a Quick Connect name refers to a pre-recorded audio disclosure endpoint. Audio Quick
 * Connects are named `{partner}_{AudioType}` (e.g. `verizon_PreRecordedDisclosures`), so we match on
 * the AudioType suffix — anchored so partner names containing underscores still match.
 */
export function isAudioQuickConnectName(name: string): boolean {
    return AUDIO_TYPES.some((audioType) => name.endsWith(`_${audioType}`));
}
